import { realApi, REAL_BASE_URL } from './api';

// Solo ADMIN/COMITE (el backend responde 403 al resto).
export const getSolicitudes = (temporada) =>
  realApi
    .get(temporada ? `/solicitudes-aplazamiento?temporada=${encodeURIComponent(temporada)}` : '/solicitudes-aplazamiento')
    .then((r) => r.datos);

export const marcarRevisada = (id) => realApi.post(`/solicitudes-aplazamiento/${id}/revisada`);

// El partido queda PROPUESTO con la incomparecencia: se confirma en Actas.
export const aplicarWo = (id) => realApi.post(`/solicitudes-aplazamiento/${id}/aplicar-wo`);

// Justificante pendiente: aprobarlo deja el partido APLAZADO sin plazo de 7 días
// (fechaJuego opcional); rechazarlo devuelve el plazo de siempre y responde
// { fechaLimite, vencido }.
export const aprobarJustificante = (id, fechaJuego) =>
  realApi.post(`/solicitudes-aplazamiento/${id}/aprobar`, { fechaJuego: fechaJuego || undefined });

export const rechazarJustificante = (id) =>
  realApi.post(`/solicitudes-aplazamiento/${id}/rechazar`).then((r) => r?.datos);

// Reprograma un aplazado ya aprobado (la jornada no cambia).
export const fijarFechaJuego = (id, fecha) => realApi.patch(`/solicitudes-aplazamiento/${id}/fecha`, { fecha });

// «Comunicar»: correo con plantilla de la BD al contrincante (CC: quien pidió el
// aplazamiento). Destinatarios y texto los calcula el servidor.
export const getComunicado = (id) =>
  realApi.get(`/solicitudes-aplazamiento/${id}/comunicado`).then((r) => r.datos);

export const comunicarAplazamiento = (id, reenviar = false) =>
  realApi.post(`/solicitudes-aplazamiento/${id}/comunicar`, { reenviar }).then((r) => r.datos);

// El justificante se pide con la cookie de sesión y se devuelve como Blob: así el
// visor (<img>/<iframe>) lo muestra desde una URL local, sin depender de las
// cabeceras de la API entre dominios.
export const getJustificante = async (id) => {
  const res = await fetch(`${REAL_BASE_URL}/solicitudes-aplazamiento/${id}/justificante`, { credentials: 'include' });
  if (!res.ok) {
    const cuerpo = await res.json().catch(() => null);
    throw new Error(cuerpo?.error || `Error ${res.status}`);
  }
  return res.blob();
};
